// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"657":"01daea27","718":"a578ffb1","942":"a5040f92"}[chunkId] + ".chunk.js";
};